module.exports = __webpack_public_path__ + "img/五人女篮.f85b91c7.png";